var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "loadingbar",
        scrollable: false,
        "click-to-close": false,
        classes: "modal-sm",
        width: 270,
        height: 150
      },
      on: { "before-open": _vm.beforeOpened }
    },
    [
      _c(
        "div",
        {
          staticClass: "spinner-border spinner-border-lg",
          attrs: { role: "status" }
        },
        [_c("span", { staticClass: "sr-only" })]
      ),
      _vm._v(" "),
      _vm.params.msg
        ? _c("div", { staticClass: "loadingBarMessage" }, [
            _c("p", {
              staticStyle: { "text-align": "center", "font-weight": "bold" },
              domProps: { innerHTML: _vm._s(_vm.$t(_vm.params.msg)) }
            })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fd08049", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd08049","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/loadingbar/LoadingBar.vue
// module id = null
// module chunks = 